import { render, staticRenderFns } from "./OrderInfoCard.vue?vue&type=template&id=320d3896&scoped=true"
import script from "./OrderInfoCard.vue?vue&type=script&lang=js"
export * from "./OrderInfoCard.vue?vue&type=script&lang=js"
import style0 from "./OrderInfoCard.vue?vue&type=style&index=0&id=320d3896&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320d3896",
  null
  
)

export default component.exports